// components/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const AuthProtected = ({ children }: ProtectedRouteProps) => {
  const auth = isAuthenticated();

  if (!auth) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
